import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Community } from '../data/schema/community';
import { CbsAccessLevel, CommunityUser } from '../data/schema/community-user';
import { ServiceHelper } from '../core/helper/services.helper';


/**
 * This guard checks to see if the user is an admin or not
 */
@Injectable()
export class AdminGuard implements CanActivate {
    constructor(private router: Router) { }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Log.debug('Admin guard... ', next, state);
        var profile = await CommunityUser.myProfile();

        // allow non-admins to create register a new user
        const forNewUser = state.url.includes('users/user') && state.url.includes('details') && next.params['id'] == 0;


        if (profile == null || (profile.accessLevel < CbsAccessLevel.Admin && !forNewUser)) {
            ServiceHelper.displayAlert('Insufficient Access', 'The page you tried accessing is restricted to a higher level of access. Please contact your community administrator for more information.')
            return false;
        }
        return true;
    }
}

@Injectable()
export class SuperAdminGuard implements CanActivate {
    constructor(private router: Router) { }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Log.debug('Super Admin guard... ', next, state);
        var profile = await CommunityUser.myProfile();
        if (profile == null || profile.accessLevel < CbsAccessLevel.Owner) {
            ServiceHelper.displayAlert('Insufficient Access', 'The page you tried accessing is restricted to a higher level of access. Please contact your community administrator for more information.')
            return false;
        }
        return true;
    }
}